import { IRowNode } from 'ag-grid-community';
import { RemoteSourceRow } from 'components/tables/data/remote-source/types';
import RemoteSourceActions from 'components/tables/data/remote-source/RemoteSourceActions';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ node, data }: { node: IRowNode<RemoteSourceRow>; data: RemoteSourceRow }) {
  return (
    <RemoteSourceActions
      {...data}
      compactOnTablet
      onStatusChange={(status: boolean) => node.setData({ ...data, status })}
    />
  );
}
